/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";
import Crypt from "../utils/src/crypt";

export const GlobalLoaderContext = React.createContext({
  active: false,
  toggle: () => {},
  start: () => {},
  stop: () => {},
});

const crypt = new Crypt();

export const GlobalAuthContext = React.createContext(
  JSON.parse(localStorage.getItem('fitinsur-session')) && JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-hdiglobal']
    ? crypt.isValidToken(
        crypt.parseJwt(crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-hdiglobal']).token)
          .exp
      )
      ? crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-hdiglobal'])
      : {
          status: false,
          username: "",
          token: "",
          person_product: [],
          user_region: "",
          firstLogin: false,
          changedPassword: false,
          forgotPassword: false,
        }
    : {
        status: false,
        username: "",
        token: "",
        person_product: [],
        user_region: "",
        firstLogin: false,
        changedPassword: false,
        forgotPassword: false,
      }
);

export const GlobalOperationContext = React.createContext({
  add_request: {},
  add_response: {},
  add2_request: {},
  add2_response: {},
  edit_request: {},
  edit_response: {},
  issue_request: {},
  issue_response: {},
  serpro_response: {},
  serpro_response_tela: [],
  list_issue_action: {},
  workflow: "",
  custom_object: {},
});
